<template>
  <div class="tabs_content">
    <section>
      <div class="filter search_only">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
      </div>

      <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="subscribers-messages">
          <table class="vypis">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <MessageRow
                v-for="message in entities"
                :message="message"
                :key="message.id"
                :isDeletable="isEditable"
                :messageTypes="messageTypes"
                :selectedEntities="selectedEntities"
                @input="select"
                @deleteMessage="onDeleteMessage" />
            <tr v-if="entities.length === 0">
              <td colspan="8" v-translate>Nebyly nalezeny žádné oznámení.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-messages"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import MessageRow from "./MessageRow";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailMessages",
  components: { MessageRow },
  mixins: [listActions],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      entities: [],
      formFields: {
        limit: 50,
        offset: 0,
        search: '',
        sort: {
          column: 'sDateCreated',
          direction: 'desc'
        }
      },
    }
  },
  created(SubscriberService, MessageService) {
    this.subscriberService = SubscriberService
    this.messageService = MessageService

    this.getEntities()
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getSubscriberMessages(this.entity.id, params).then((data) => {
        this.entities = data['messages']
        this.totalCount = data['totalCount']
      })
    },
    onDeleteMessage(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteMessage');
      } else {
        this.messageService.deleteRecipient(id)
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.getEntities()
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeleteMessage(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getSubscriberMessages(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['messages']);
      })
    },
  },
  computed: {
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sMessageName' },
        { id: 2, name: this.$gettext('Typ zprávy') },
        { id: 3, name: this.$gettext('Přečteno') },
        { id: 4, name: this.$gettext('Smazáno') },
        { id: 5, name: this.$gettext('Vynucené potvrzení') },
        { id: 6, name: this.$gettext('Datum odeslání'), column: 'sDateCreated' },
      ]
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'messageType': {
          name: this.$gettext('Typ zprávy'), callback: (entity) => {
            return this.messageTypes[entity.message_type]
          }
        },
        'is_readed': {
          name: this.$gettext('Přečteno'), callback: (entity) => {
            return entity.is_readed ? (this.$_datetime_format(entity.is_readed) + ', ' + entity.name_device_read) : this.$gettext("Ne")
          }
        },
        'is_deleted': {
          name: this.$gettext('Smazáno'), callback: (entity) => {
            return entity.deleted ? (this.$_datetime_format(entity.deleted) + ', ' + entity.name_device_delete) : this.$gettext("Ne")
          }
        },
        'forced_confirmation': {
          name: this.$gettext('Vynucené potvrzení'), callback: (entity) => {
            return entity.forced_confirmation ? this.$_datetime_format(entity.forced_confirmation) : this.$gettext("Ne")
          }
        },
        'timestamp_created': { name: this.$gettext('Datum odeslání') },
      }
    },
    messageTypes() {
      return {
        'info': this.$gettext('Informativní sdělení'),
        'maintenance_info': this.$gettext('Servisní informace'),
        'new_service': this.$gettext('Nová služba'),
        'fault': this.$gettext('Porucha'),
        'maintenance': this.$gettext('Servis'),
        'billing': this.$gettext('Platby')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/messages/Messages.vue